import React, { useEffect, useRef, useState } from 'react';
import { toYouTubeEmbedSrc } from '../../utils/urls';
import { loadYouTubeApi } from '../../utils/youtubeApi';
import './webinarPlayer.css';

export default function WebinarPlayer({ embedLink, title = 'Diretta webinar' }) {
  const host = useRef(null);
  const playerRef = useRef(null);
  const [muted, setMuted] = useState(false);
  const [playing, setPlaying] = useState(false);
  const [blocked, setBlocked] = useState(false);

  useEffect(() => {
    let disposed = false;
    let retriedMuted = false;
    const container = host.current;
    const iframe = document.createElement('iframe');
    const src = new URL(toYouTubeEmbedSrc(embedLink));
    src.searchParams.set('enablejsapi', '1');
    src.searchParams.set('origin', window.location.origin);
    iframe.src = src.toString();
    iframe.title = title;
    iframe.setAttribute('frameborder', '0');
    iframe.setAttribute('allow', 'autoplay; encrypted-media');
    iframe.setAttribute('referrerpolicy', 'strict-origin-when-cross-origin');
    iframe.setAttribute('sandbox', 'allow-scripts allow-same-origin allow-presentation');
    container.appendChild(iframe);
    setMuted(false);
    setPlaying(false);
    setBlocked(false);

    loadYouTubeApi().then((YT) => {
      if (disposed) return;
      playerRef.current = new YT.Player(iframe, {
        events: {
          onReady: ({ target }) => {
            if (!disposed) target.playVideo();
          },
          onAutoplayBlocked: ({ target }) => {
            if (disposed) return;
            setBlocked(true);
            if (!retriedMuted) {
              retriedMuted = true;
              target.mute();
              setMuted(true);
              target.playVideo();
            }
          },
          onStateChange: ({ data }) => {
            if (disposed) return;
            setPlaying(data === 1);
            if (data === 1) setBlocked(false);
          },
        },
      });
    }).catch(() => {
      // Leave the native YouTube play button reachable if its API is unavailable.
    });

    return () => {
      disposed = true;
      playerRef.current?.destroy();
      playerRef.current = null;
      container.replaceChildren();
    };
  }, [embedLink, title]);

  const startWithAudio = () => {
    const player = playerRef.current;
    if (!player) return;
    // Keep these calls synchronous with the tap: mobile audio requires a gesture.
    player.unMute();
    player.setVolume(100);
    player.playVideo();
    setMuted(false);
    setBlocked(false);
  };

  return (
    <div className="webinar-player">
      <div ref={host} className="webinar-player__frame" />
      {(muted || blocked) && (
        <button type="button" className="webinar-player__action" onClick={startWithAudio}>
          {playing && muted ? 'Attiva audio' : 'Avvia diretta'}
        </button>
      )}
    </div>
  );
}
